import React, { useState, useEffect } from 'react';
import styles from "./money.module.css";
import Payment from './page/payment';
import MenuManagement from './page/menu';
import PrintList from './page/print';
import PaymentConfig from './page/paymentconfig';
import ManagePayment from './page/managepayment';
import AdditionalConfig from './page/additionalconfig';
import NewPayLinkSend from './page/newpaylinksend';
import TotalPayment from './page/totalpayment';

const Money: React.FC<any> = (props) => {

    const [selectMenu, setSelectMenu] = useState("payment");

    useEffect(() => {
        props.activateMenuList("money");
    }, []);

    const changeSelectedMenu = (e: any, menu: string) => {
        setSelectMenu(menu);
    }

    return (
        <div className="main22" style={{
        }}>
            <div className="title" style={{
                display: "flex", alignItems: "center",
            }}>
                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        paddingTop: "6px",
                        marginRight: "10px"
                    }}
                >
                    <img src="img/off/money.svg" alt="playlist" style={{ width: "18px" }} />
                </div>
                <div>결제 관리</div>
            </div>

            <div className={styles.selectMenu}>
                <div onClick={(e) => { changeSelectedMenu(e, "payment") }} className={`selectedMenu ${selectMenu === "payment" ? "active" : ""}`}>
                    결제 현황
                </div>
                {
                    (props.user && props.user.todoistApiKey) ?
                        <div onClick={(e) => { changeSelectedMenu(e, "totalpayment") }} className={`selectedMenu ${selectMenu === "totalpayment" ? "active" : ""}`}>
                            매출 현황
                        </div>
                        :
                        ""
                }
                <div onClick={(e) => { changeSelectedMenu(e, "newlink") }} className={`selectedMenu ${selectMenu === "newlink" ? "active" : ""}`}>
                    신규 결제링크
                </div>
                <div onClick={(e) => { changeSelectedMenu(e, "winterpayment") }} className={`selectedMenu ${selectMenu === "winterpayment" ? "active" : ""}`}>
                    윈터 결제 현황
                </div>
                <div onClick={(e) => { changeSelectedMenu(e, "config") }} className={`selectedMenu ${selectMenu === "config" ? "active" : ""}`}>
                    등록비 설정
                </div>
                <div onClick={(e) => { changeSelectedMenu(e, "menu") }} className={`selectedMenu ${selectMenu === "menu" ? "active" : ""}`}>
                    컨텐츠 메뉴 관리
                </div>
                <div onClick={(e) => { changeSelectedMenu(e, "additionalconfig") }} className={`selectedMenu ${selectMenu === "additionalconfig" ? "active" : ""}`}>
                    부가 항목 설정
                </div>
            </div>

            {
                selectMenu === "payment" ? 
                <ManagePayment user={props.user} /> : ""
            }
            {
                selectMenu === "totalpayment" ?
                <TotalPayment user={props.user} /> : ""
            }
            {
                selectMenu === "newlink" ?
                <NewPayLinkSend user={props.user} /> : ""
            }
            {
                selectMenu === "menu" ?
                <MenuManagement /> : ""
            }
            {
                selectMenu === "print" ?
                <PrintList user={props.user} /> : ""
            }
            {
                selectMenu === "config" ?
                <PaymentConfig user={props.user} /> : ""
            }
            {
                selectMenu === "additionalconfig" ?
                <AdditionalConfig user={props.user} /> : ""
            }

        </div>
    )
}

export default Money;